import {Pipe, PipeTransform} from '@angular/core';
import {Router} from '@angular/router';

@Pipe({
  name: 'routerActive',
  standalone: true,
})
export class RouterActivePipe implements PipeTransform {
  constructor(private readonly router: Router) {}

  transform(url: string): string {
    return this.router.url.split('/')[1] === url.split('/')[1] &&
      this.router.url.split('/')[2] === url.split('/')[2]
      ? 'active'
      : '';
  }
}
